module.exports = __webpack_public_path__ + "img/company_logo.cc02be67.png";